// Authentication Claims
export const CLAIMS = {
  TP_READER: "tp-reader",
  DEV_ACCESS: "dev-access",
};

// Environment URLs
export const UAT_DOMAIN_HOST =
  process.env.UAT_DOMAIN_HOST || "https://nexus-assistants-uat.bpweb.bp.com";

/** Assistants Management API base URL (evaluation projects, pipeline trigger/status/logs/metrics).
 *  Resolution order:
 *  1. API_ENVIRONMENT (runtime, server-side only — set by Helm chart) → hardcoded absolute URL per env.
 *  2. NEXT_PUBLIC_MANAGEMENT_API_URL (build-time override, client-side).
 *  3. Relative path fallback — works in the browser on any domain; not valid for server-side fetch. */
const MANAGEMENT_API_URLS: Record<string, string> = {
  DEV: "https://nexus-dev.bpweb.bp.com/_services/management",
  UAT: "https://nexus-assistants-uat.bpweb.bp.com/_services/management",
  PROD: "https://nexus-assistants.bpglobal.com/_services/management",
};
export const MANAGEMENT_API_BASE_URL =
  MANAGEMENT_API_URLS[process.env.API_ENVIRONMENT ?? ""] ||
  process.env.NEXT_PUBLIC_MANAGEMENT_API_URL ||
  "/_services/management";

// API Endpoints
export const API_ENDPOINTS = {
  // Frontend API routes (Next.js)
  COPILOTKIT: "/api/copilotkit",
  ASSISTANTS: "/api/assistants",
  // Backend API routes (Axel)
  COPILOTKIT_INFO: "/agui/copilotkit/info",
  COPILOTKIT_BASE: "/agui/copilotkit",
  DATASOURCES: (name: string) => `/api/datasources/${name}`,
} as const;

// HTTP Headers
export const HTTP_HEADERS = {
  CONTENT_TYPE: "Content-Type",
  AUTHORIZATION: "Authorization",
  CONTENT_TYPE_JSON: "application/json",
  CONTENT_TYPE_SSE: "text/event-stream",
  CACHE_CONTROL: "Cache-Control",
  CONNECTION: "Connection",
  X_SPACE_NAME: "X-Space-Name",
} as const;

// Request Configuration
export const REQUEST_CONFIG = {
  TIMEOUT_MS: 120000, // 2 minutes
  CACHE_NO_CACHE: "no-cache",
  CONNECTION_KEEP_ALIVE: "keep-alive",
} as const;

// Tool Types
export const TOOL_TYPES = {
  RETRIEVAL: "retrieval",
  MCP_PROXY: "mcp_proxy",
  AGENT: "agent",
} as const;

// Pagination
export const ONBOARD_PAGE_SIZE = 25;
export const ASSISTANTS_PAGE_SIZE = 200;
export const ASSISTANTS_CARD_MAX_ITEMS = 10;
export const ONBOARD_LIST_MAX_HEIGHT = "600px";
export const ONBOARD_STATIC_LIST_MAX_HEIGHT = "600px";
